/* unplugin-vue-components disabled */import script from "./layout-index.vue?vue&type=script&setup=true&lang=ts"
export * from "./layout-index.vue?vue&type=script&setup=true&lang=ts"

import "./layout-index.vue?vue&type=style&index=0&id=6474843d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6474843d"]])

export default __exports__